/**
 * CapitalQuotePage
 * ----------------
 * Full-page screen for the Project Quote builder (was a modal). Route:
 *   /admin/proposals/quote/new
 *   /admin/proposals/quote/:id
 */
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "@/App";
import CapitalQuoteBuilder from "@/components/admin/CapitalQuoteBuilder";

export default function CapitalQuotePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { token } = useAuth();
  const back = () => navigate("/admin/proposals");

  return (
    <CapitalQuoteBuilder
      open
      pageMode
      editingId={id && id !== "new" ? id : null}
      token={token}
      onClose={back}
      onSaved={back}
    />
  );
}
